/**
 * Barra de progresso do carrinho — só a animação.
 *
 * Toda a regra (quais etapas existem, onde ficam, qual mensagem aparece) é
 * resolvida no servidor pelo snippet `free-shipping`, que já entrega
 * `--percent` correto no atributo style. Aqui só interpolamos do valor atual
 * até o alvo, para a barra não saltar quando o carrinho muda.
 *
 * Antes este arquivo recalculava o texto e escondia divs por conta própria.
 * Com duas etapas isso passou a brigar com o servidor: quem sabe qual etapa
 * vem primeiro é o Liquid, que conhece os dois valores.
 */
if (!customElements.get('free-shipping-progress-bar')) {
  class CartProgressBar extends HTMLElement {
    connectedCallback() {
      var target = parseFloat(this.dataset.progress);
      if (isNaN(target)) return;

      // De onde sair: o valor que o servidor ja pintou, para animar a partir
      // dele em vez de recomecar do zero a cada render.
      var current = parseFloat(this.style.getPropertyValue('--percent'));
      if (isNaN(current)) current = 0;

      if (Math.abs(target - current) < 0.5) {
        this.style.setProperty('--percent', target + '%');
        return;
      }

      this.animate(current, target);
    }

    animate(from, to) {
      var self = this;
      var duration = 350;
      var startTime = performance.now();
      var ease = function (t) {
        return t * (2 - t);
      };

      var frame = function (now) {
        var progress = Math.min((now - startTime) / duration, 1);
        var value = from + (to - from) * ease(progress);
        self.style.setProperty('--percent', value + '%');
        if (progress < 1) requestAnimationFrame(frame);
      };

      requestAnimationFrame(frame);
    }
  }

  customElements.define('free-shipping-progress-bar', CartProgressBar);
}
